import { Card } from "@/app/admin/_common/ui/card";
import type { LocationKpis } from "@/app/_services/LocationService";

const currencyFormat = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
const numberFormat = new Intl.NumberFormat("en-US");

export default function LocationDetailKpiRow({ kpis }: { kpis: LocationKpis }) {
  const tiles = [
    {
      label: "Total revenue",
      value: currencyFormat.format(kpis.revenue),
      caption: "All time",
    },
    {
      label: "Shows",
      value: numberFormat.format(kpis.num_shows),
      caption: "All time",
    },
    {
      label: "Avg capacity",
      value: numberFormat.format(Math.round(kpis.avg_capacity)),
      caption: "Per show",
    },
    {
      label: "Tickets available",
      value: numberFormat.format(kpis.tickets_available),
      caption: "All time",
    },
    {
      label: "Tickets sold",
      value: numberFormat.format(kpis.tickets_sold),
      caption: "All time",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2.5 lg:grid-cols-5">
      {tiles.map((tile) => (
        <Card key={tile.label} className="rounded-md p-3.5 shadow-none">
          <div className="mb-1 text-[11.5px] font-medium text-muted-foreground">
            {tile.label}
          </div>
          <div className="text-[21px] font-bold leading-none tracking-tight text-foreground">
            {tile.value}
          </div>
          <div className="mt-1.5 text-[11.5px] text-muted-foreground/70">
            {tile.caption}
          </div>
        </Card>
      ))}
    </div>
  );
}
